import { Coffee } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface AfterHoursLogoProps {
  className?: string;
}

export function AfterHoursLogo({ className }: AfterHoursLogoProps) {
  return (
    <div className={cn("relative", className)}>
      <Coffee className="w-full h-full text-primary" strokeWidth={1.5} />
    </div>
  );
}
